import { Fab, Popper } from "@mui/material";

import { ElementMemo } from "./ElementMemo";
import { ArrowUpIcons, Ellipsis } from "../../../icons";

export default function ElementDropdown(props) {
  const {
    allElementAnchorEl,
    autoOpen,
    classes,
    element,
    experienceAnchorEl,
    fabDropdown,
    fabRef,
    forcePopoverOpen,
    handleEllipsisClick,
    handleEllipsisClose,
    handleExperienceGroup,
    handlePopoverToggle,
    isMap,
    lastElementRef,
    lastMapElementRef,
    open,
    speedElements,
    tabStatus,
    locked,
  } = props;

  const showPopper = open || (allElementAnchorEl && autoOpen);
  return fabDropdown ? (
    <>
      <Fab
        color="primary"
        sx={{
          marginTop: "8px",
          "&:hover": {
            backgroundColor: "#640227",
          },
        }}
        onClick={(e) => {
          if (open) {
            handleEllipsisClose(e);
          } else {
            handleEllipsisClick(e);
          }
        }}
        ref={allElementAnchorEl && fabRef}
      >
        {showPopper ? <ArrowUpIcons htmlColor="white" /> : <Ellipsis htmlColor="white" />}
      </Fab>
      {showPopper && (
        <Popper
          open={showPopper}
          anchorEl={allElementAnchorEl}
          sx={{
            zIndex: 3000,
            display: "flex",
            flexDirection: "column",
            marginTop: "72px",
          }}
          placement="bottom"
          modifiers={[
            {
              name: "offset",
              options: {
                offset: [0, 10],
              },
            },
          ]}
        >
          {speedElements?.map((el) => {
            return (
              <ElementMemo
                isMobile
                tabStatus={tabStatus}
                key={el.id}
                newRef={isMap ? lastMapElementRef : lastElementRef}
                anchor={experienceAnchorEl[el.id]}
                elementPositioning="experience"
                elementData={el}
                onPopoverToggle={handlePopoverToggle}
                isOpen={el.id === element.id}
                forcePopoverOpen={forcePopoverOpen(el.id)}
                locked={locked}
              />
            );
          })}
        </Popper>
      )}
    </>
  ) : (
    <div className={classes.experienceGroupPositioning}>
      <div ref={handleExperienceGroup} className={classes.elementContainer}>
        {speedElements.map((el) => {
          return (
            <ElementMemo
              tabStatus={tabStatus}
              key={el.id}
              newRef={isMap ? lastMapElementRef : lastElementRef}
              anchor={experienceAnchorEl[el.id]}
              elementPositioning="experience"
              elementData={el}
              onPopoverToggle={handlePopoverToggle}
              isOpen={el.id === element.id}
              forcePopoverOpen={forcePopoverOpen(el.id)}
              locked={locked}
            />
          );
        })}
      </div>
    </div>
  );
}
